import {Typography} from '~library/atoms/Typography';

export const InfoWarning = ({visibility}) => (
  <Typography
    className="filled-slot__visibility-disclaimer"
    variant="label2"
    size="smaller"
    color="pebble"
  >
    {visibility === 'public' ? 'Visible to all' : 'Visible to you and the organizer'}
  </Typography>
);
